import { SetterOrUpdater } from "recoil";
import {
  catchError,
  from,
  interval,
  Observable,
  Subscription,
  switchMap,
  takeWhile,
  tap,
} from "rxjs";

import { ProcessStatusEnum } from "../../enums";
import { IRydeProcess } from "../../models";
import { Log } from "../log.helpers";

const POLLING_INTERVAL = 1000;
export const pollingMap = new Map<number, Subscription>();

interface IStartPollingArguments {
  id: number;
  intervalMs?: number;
  fetchProcess: (id: number) => Promise<IRydeProcess | undefined>;
  setProcess: SetterOrUpdater<Map<number, IRydeProcess>>;
  onError?: (
    err: unknown,
    caught: Observable<IRydeProcess | undefined>,
  ) => void;
}

export const startPolling = ({
  id,
  intervalMs = POLLING_INTERVAL,
  fetchProcess,
  setProcess,
  onError,
}: IStartPollingArguments): void => {
  if (pollingMap.has(id)) {
    return;
  }

  const sub = interval(intervalMs)
    .pipe(
      switchMap(() => from(fetchProcess(id))),
      tap(data => {
        if (data) {
          setProcess(prev => {
            const copy = new Map(prev);
            copy.set(id, data);
            return copy;
          });
        }
      }),
      takeWhile(
        rideProcess => rideProcess?.status === ProcessStatusEnum.Pending,
      ),
      catchError((err, caught) => {
        Log.error(err);
        onError?.(err, caught);
        return caught;
      }),
    )
    .subscribe();

  pollingMap.set(id, sub);
};

export const stopPolling = (id: number) => {
  const sub = pollingMap.get(id);

  if (sub) {
    sub.unsubscribe();
    pollingMap.delete(id);
  }
};

export const stopAllPolling = () => {
  pollingMap.forEach(sub => sub.unsubscribe());
  pollingMap.clear();
};
